export const publicPrimaryNavItems = [
  { label: "Stellenbörse", href: "/stb/job-marketplace", matches: ["/stb/job-marketplace"] },
  { label: "Roadmap", href: "/roadmap", matches: ["/roadmap", "/public/roadmap"] },
  { label: "Leitbild", href: "/leitbild", matches: ["/leitbild"] },
  { label: "Nachrichten", href: "/nachrichten", matches: ["/nachrichten"], prefixes: ["/nachrichten/"] },
  { label: "Support", href: "/menue/support", matches: ["/menue/support"] },
];

export const publicActionNavItems = [
  { key: "quickcheck", label: "QuickCheck", href: "/applicant/frontdoor?entry=abroad" },
  { key: "login", label: "Anmelden", href: "/login" },
  { key: "register", label: "Registrieren", href: "/register" },
];

export const publicMarketingNavItems = publicPrimaryNavItems;
export const publicAuthNavItems = publicPrimaryNavItems;

export const publicFooterGroups = [
  {
    title: "Navigation",
    items: [
      { label: "Startseite", href: "/" },
      { label: "Nachrichten", href: "/nachrichten" },
      { label: "Roadmap", href: "/roadmap" },
      { label: "Leitbild", href: "/leitbild" },
      { label: "Stellenbörse", href: "/stb/job-marketplace" },
    ],
  },
  {
    title: "Orientierung",
    items: [
      { label: "Support", href: "/menue/support" },
      { label: "Tools", href: "/menue/tools" },
      { label: "Qualifikationen", href: "/menue/quali" },
      { label: "Erfolg", href: "/menue/success" },
    ],
  },
  {
    title: "Rechtliches",
    items: [
      { label: "Impressum", href: "/impressum" },
      { label: "AGB", href: "/agb" },
      { label: "Datenschutz", href: "/datenschutz" },
    ],
  },
];

export const publicFamilyAuditRoutes = [
  "/",
  "/leitbild",
  "/roadmap",
  "/public/roadmap",
  "/nachrichten",
  "/login",
  "/register",
  "/applicant/frontdoor",
  "/menue/support",
  "/menue/tools",
  "/menue/quali",
  "/menue/success",
  "/impressum",
  "/agb",
  "/datenschutz",
  "/stb/job-marketplace",
];

export function isPublicNavItemActive(item, pathname) {
  const normalizedPath = String(pathname || "").split("?")[0];
  const matches = Array.isArray(item?.matches) && item.matches.length ? item.matches : [item?.href];
  const prefixes = Array.isArray(item?.prefixes) ? item.prefixes : [];
  return matches.some((value) => value === normalizedPath) || prefixes.some((value) => normalizedPath.startsWith(value));
}
